import React from 'react';
import PropTypes from 'prop-types';

/**
 * Card component for web
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Card content
 * @param {React.ReactNode} props.header - Optional header content
 * @param {React.ReactNode} props.footer - Optional footer content
 * @param {boolean} props.elevated - Whether to use elevated shadow
 * @param {boolean} props.hoverable - Whether card has hover effect
 * @param {Function} props.onPress - Optional click handler (makes card interactive)
 * @param {string} props.className - Additional CSS classes
 */
const Card = ({
  children,
  header,
  footer,
  elevated = false,
  hoverable = false,
  onPress,
  className = '',
  ...props
}) => {
  const isInteractive = !!onPress;

  const cardClasses = [
    'card',
    elevated && 'shadow-elevated',
    (hoverable || isInteractive) && 'transition-shadow duration-200 hover:shadow-cardHover cursor-pointer',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const CardWrapper = isInteractive ? 'button' : 'div';

  return (
    <CardWrapper
      className={cardClasses}
      onClick={onPress}
      type={isInteractive ? 'button' : undefined}
      {...props}
    >
      {header && <div className="card-header">{header}</div>}
      <div className={header || footer ? 'card-body' : 'p-6'}>{children}</div>
      {footer && <div className="card-footer">{footer}</div>}
    </CardWrapper>
  );
};

Card.propTypes = {
  children: PropTypes.node.isRequired,
  header: PropTypes.node,
  footer: PropTypes.node,
  elevated: PropTypes.bool,
  hoverable: PropTypes.bool,
  onPress: PropTypes.func,
  className: PropTypes.string,
};

export default Card;
